exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1zYpo {\n  position: relative;\n}\n._2sNEc {\n  height: 84px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_1zYpo",
	"placeholder": "_2sNEc"
};